import { serverPath } from '@app/utils/server-path';
import { xhrHeaders } from '@lib/utils';
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

type AuthState = {
  isAuthenticated: boolean;
  isLoading: boolean;
  isFirstAuthCheck: boolean;
  error: string | null;
};

const initialState: AuthState = {
  isAuthenticated: false,
  isLoading: false,
  isFirstAuthCheck: true,
  error: null,
};

export const checkAuth = createAsyncThunk('auth/checkAuth', async (_, { rejectWithValue }) => {
  try {
    const response = await fetch(serverPath.checkAuth, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...xhrHeaders(),
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data?.result?.is_authenticated || false;
  } catch (error) {
    return rejectWithValue((error as Error).message);
  }
});

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout(state) {
      state.isAuthenticated = false;
      state.isLoading = false;
      state.error = null;
      // При логауте не сбрасываем isFirstAuthCheck, так как первая проверка уже была
    },
    loginSuccess(state) {
      state.isAuthenticated = true;
      state.isLoading = false;
      state.error = null;
      // При логине не сбрасываем isFirstAuthCheck, так как первая проверка уже была
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkAuth.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(checkAuth.fulfilled, (state, action: PayloadAction<boolean>) => {
        state.isAuthenticated = action.payload;
        state.isLoading = false;
        state.isFirstAuthCheck = false; // После первой проверки больше не показываем скелетон
      })
      .addCase(checkAuth.rejected, (state, action) => {
        state.error = action.payload as string;
        state.isLoading = false;
        state.isFirstAuthCheck = false; // Даже при ошибке первая проверка завершена
      });
  },
});

export const { logout, loginSuccess } = authSlice.actions;

export default authSlice.reducer;
